var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 17"
}, props), /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 20,
  height: 17
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8C8C8C",
  fillRule: "evenodd",
  d: "M16.494 12.338c2.235 0 3.106 1.046 3.106 3.444a.57.57 0 0 1-.565.574H.965a.57.57 0 0 1-.565-.574c0-2.398.87-3.444 3.106-3.444Zm0 1.148H3.506c-1.386 0-1.867.387-1.96 1.722H18.46s-.043-.57-.19-.919c-.253-.604-.782-.803-1.775-.803ZM11.694 0a.57.57 0 0 1 .565.574.57.57 0 0 1-.565.574h-1.13l.001 1.734c4.95.22 7.906 3.35 7.906 7.735a.57.57 0 0 1-.565.574H2.094a.57.57 0 0 1-.565-.574c0-4.384 2.956-7.515 7.906-7.735V1.148h-1.13a.57.57 0 0 1-.564-.574A.57.57 0 0 1 8.306 0ZM10 4.017c-4.07 0-6.624 2.044-7.211 5.161-.086.458-.113.865-.113.865h14.646C17.073 6.447 14.439 4.017 10 4.017"
}))));
export default SvgTc;